import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'

import auth from './modules/auth'
import user from './modules/user'
import account from './modules/account'
import category from './modules/category'
import customer from './modules/customer'
import company from './modules/company'
import dashboard from './modules/dashboard'
import superAdminDashboard from './modules/superAdmin-dashboard'
import estimate from './modules/estimate'
import expense from './modules/expense'
import invoice from './modules/invoice'
import preapprovedinvoice from './modules/preapprovedInvoice'
import userProfile from './modules/settings/user-profile'
import companyInfo from './modules/settings/company-info'
import preferences from './modules/settings/preferences'
import general from './modules/settings/general'
import contact from './modules/settings/contact'
import taxType from './modules/settings/tax-type'
import payment from './modules/payment'
import item from './modules/item'
import modal from './modules/modal'
import currency from './modules/currency'
import profitLossReport from './modules/reports/profit-loss'
import salesReport from './modules/reports/sales'
import ExpensesReport from './modules/reports/expense'
import TaxReport from './modules/reports/tax'
import anchorDashboard from './modules/anchor-dashboard'
import funderDashboard from './modules/funder-dashboard'
import auditorDashboard from './modules/auditor-dashboard'
import LoanRequest from './modules/loan-request'
import Backup from './modules/backup'
import documentType from './modules/documentType'
import prepayment from './modules/prepayment'
import financialFacility from './modules/profile/financial-facility'
import business from './modules/profile/business'
import profileSharing from './modules/profile/sharingProfile'
import stakeholder from './modules/profile/stakeholder'
import supplier from './modules/supplier'
import funder from './modules/funder'
// import auditor from './modules/auditor'
import settlement from './modules/settlement'
import companyImpactOthers from './modules/companyImpactOthers'
import po from './modules/po'
import deliveryNote from './modules/deliveryNote'
import communication from './modules/communication'
import userGuide from './modules/user-guide'
import userManagements from './modules/user-managements'
import emailTemplates from './modules/emailTemplates'
import emailActionList from './modules/emailActionList'
import financesForms from './modules/financesForms'
import OfferToSell from './modules/offerToSell'
import islamicFinanceForm from './modules/islamicFinanceForms'
import islamicFormTemplate from './modules/islamicFormTemplate'
Vue.use(Vuex)

const initialState = {
  isAppLoaded: false
}

export default new Vuex.Store({
  strict: true,
  state: initialState,
  getters,
  mutations,
  actions,

  modules: {
    auth,
    user,
    account,
    category,
    company,
    companyInfo,
    customer,
    dashboard,
    superAdminDashboard,
    estimate,
    item,
    invoice,
    preapprovedinvoice,
    expense,
    modal,
    userProfile,
    currency,
    payment,
    preferences,
    general,
    taxType,
    profitLossReport,
    salesReport,
    ExpensesReport,
    TaxReport,
    anchorDashboard,
    funderDashboard,
    auditorDashboard,
    LoanRequest,
    Backup,
    documentType,
    prepayment,
    stakeholder,
    financialFacility,
    business,
    supplier,
    funder,
    // auditor,
    settlement,
    contact,
    companyImpactOthers,
    po,
    profileSharing,
    deliveryNote,
    communication,
    userGuide,
    userManagements,
    emailTemplates,
    emailActionList,
    financesForms,
    OfferToSell,
    islamicFinanceForm,
    islamicFormTemplate
  }
})
